import { createCrudService } from "@dgs/core";
import { BranchCreateDto, BranchListDto, BranchOptionDto, BranchShowDto, BranchUpdateDto } from "apiGen";

export const branchService = createCrudService<
	BranchListDto,
	BranchOptionDto,
	BranchShowDto,
	BranchCreateDto,
	BranchUpdateDto
>(["branches"]);
